import React from "react"
import { useParams } from "react-router-dom"

// components
import ProtocolMaintenance from "./subcomponents/ProtocolMaintenance/ProtocolMaintenance"
import ClinicalTrialsGov from "./subcomponents/ClinicalTrialsGov/ClinicalTrialsGov"
import Loading from "../../../../../components/Loading/Loading"
import { Flex } from "antd"

// styles
import "./Registries.scss"

// context
import { useGetStudy } from "api/hooks/studies/useStudiesApi"

// api
import { useGetStudyProtocolDataCompare, useGetStudyRegistryData } from "api/hooks/studies/useRegistries"

const Registries = () => {
  const { studyId } = useParams()
  const { data: study } = useGetStudy(studyId)
  const {
    data: registryData = [],
    refetch: refetchRegistryData,
    isLoading: isRegistryDataLoading,
  } = useGetStudyRegistryData(study?.authoring_study_id)

  const {
    data: protocolDataCompare = [],
    refetch: refetchProtocolData,
    isLoading: isProtocolDataCompareLoading,
    status,
  } = useGetStudyProtocolDataCompare(study?.authoring_study_id)

  // NOTE: isLoading is true when data is fetched for the first time. When changing tabs the data is refetched

  React.useEffect(() => {
    // NOTE: study.authoring_study_id is null initially
    if (study?.authoring_study_id) {
      refetchProtocolData()
      refetchRegistryData()
    }
  }, [study?.authoring_study_id])

  if (status === "pending" || isProtocolDataCompareLoading || isRegistryDataLoading) return <Loading />

  return (
    <Flex
      gap={12}
      style={{ width: "100%" }}
    >
      <ProtocolMaintenance
        study={study}
        protocolDataCompare={protocolDataCompare}
        clinicalTrialsData={registryData}
      />
      <ClinicalTrialsGov clinicalTrialsData={registryData} />
    </Flex>
  )
}

export default Registries
